import { combineEpics } from "redux-observable";
import * as whiteboard from "./whiteboard";
import * as mutate from "./mutate";
import * as products from "./products";
import * as shipping from "./shipping-accounts";
import * as shippingPromotions from "./shipping-promotions";
import * as adminEpics from "./admin";
import * as userEpics from "./user";
import * as dashboard from "./dashboard";
import * as catalogs from "./catalogs";
import * as collections from "./collections";
import * as globalProducts from "./global-products";
import * as filters from "./filters";
import * as utilities from "./utilities";
import * as authentication from "./authentication";
import * as scope from "./scope";
import * as contacts from "./contacts-epic";
import * as companyDiscounts from "./company-discounts-epic";
import * as recentOrders from "./recent-orders-epic";
import * as shippingRates from "./shipping-rates";
import * as dataflow from "./utilities/dataflow-epics";
import * as working from "./working-order-epic";
import * as cancelledStyles from "./cancelled-styles-epic";
import * as timeline from "./timeline";
import * as subscriptions from "./subscriptions";
import * as merchant from "./merchant";
import * as sizeFamilies from "./size-families-epic";
import * as productSizesOverrides from "./sizes-overrides-epic";
import * as brandSizesOverrides from "./brand-sizes-overrides-epic";
import * as sizeCompliance from "./size-compliance-epic";
import * as allocationDimension from "./allocation-dimension";
import * as productMedia from "./product-media-epic";
import * as unlinkedMedia from "./unlinked-media-epic";
import * as uploadBuyers from "./upload-buyers.epic";
import * as sentryEpics from "./sentry";
import * as customizationEpic from "./customizations-epic";
import * as Sentry from "@sentry/browser"; // error tacking
import * as notifications from "./notification-epic";
import * as colorSwatches from "./color-swatches";
import * as payments from "./payments";
import * as atsCustomTemplatesEpic from "./ats-custom-templates-epic";
import * as atsExportEpic from "./ats-export-epic";
import * as merchantAdminAccountEpics from "./merchant-admin-account-epics";
import * as merchantAdminMemberListEpics from "./merchant-admin-member-list-epics";
import * as merchantAdminMemberDetailsEpics from "./merchant-admin-member-details-epics";
import * as brandsDataEpic from "./brands-data-epic";
import * as accessControlEpic from "./access-control-epic";
import * as variants from "./variants";
import * as watermarking from "./watermarking-epic";
import * as buyerDashboard from "./buyer-dashboard-epic";
import * as pos from "epics/pos-epic";
import * as deliveryWindows from "epics/delivery-windows";
import * as inventory from "epics/inventory";
import * as merchantEnablements from "./merchant-enablements";
import * as cartGridView from "epics/cart-grid-view";
import * as cartNotifications from "epics/cart-notifications";
import * as workingOrder from "epics/working-order";
import * as insightsEpic from "epics/insights";
import * as companies from "epics/companies";

const createEpicArray = (...epicObjects) => {
    const epicArray = [];
    epicObjects.forEach((epicObject) => {
        Object.keys(epicObject).forEach((key) => {
            const value = epicObject[key];
            if (typeof value === "function") {
                epicArray.push(value);
            }
        });
    });

    return epicArray;
};

const epics = createEpicArray(
    whiteboard,
    mutate,
    products,
    shipping,
    shippingPromotions,
    adminEpics,
    userEpics,
    dashboard,
    catalogs,
    companyDiscounts,
    collections,
    globalProducts,
    filters,
    utilities,
    authentication,
    scope,
    contacts,
    recentOrders,
    shippingRates,
    dataflow,
    working,
    cancelledStyles,
    timeline,
    subscriptions,
    productMedia,
    unlinkedMedia,
    merchant,
    sizeFamilies,
    productSizesOverrides,
    brandSizesOverrides,
    sizeCompliance,
    notifications,
    allocationDimension,
    colorSwatches,
    payments,
    uploadBuyers,
    sentryEpics,
    atsCustomTemplatesEpic,
    atsExportEpic,
    buyerDashboard,
    merchantAdminAccountEpics,
    merchantAdminMemberListEpics,
    merchantAdminMemberDetailsEpics,
    merchantEnablements,
    brandsDataEpic,
    customizationEpic,
    accessControlEpic,
    watermarking,
    variants,
    pos,
    deliveryWindows,
    inventory,
    cartGridView,
    cartNotifications,
    workingOrder,
    insightsEpic,
    companies
);

export const rootEpic = (action$, store) =>
    combineEpics(...epics)(action$, store).catch((err, source) => {
        process.nextTick(() => {
            // tslint:disable-next-line
            if (process.env.NODE_ENV !== "development") {
                // eslint-disable-next-line no-alert
                alert(`Unexpected error: ${err}. Page will refresh.`);
            }
            try {
                Sentry.captureException(err);
            } catch (e) {
                // ignore
            }
            // tslint:disable-next-line
            if (process.env.NODE_ENV !== "development") {
                process.nextTick(() => window.location.reload());
            }
            throw err;
        });
        return source;
    });
